export const CLASS_FEATURE_CHOICE_SET_REQUEST = 'character.CLASS_FEATURE_CHOICE_SET_REQUEST';
